module.exports = __webpack_public_path__ + "c24eab5d3b54529943f859a5871b509e.svg";